import { createGlobalStyle } from "styled-components";

export const Typography = createGlobalStyle`
 

 h1, h2, h3 {
    font-size: 1rem;
    font-weight: bold;
  }

  p {
    font-size: 0.75rem;
  }
 
`